import { Component, Input, OnChanges, inject } from '@angular/core';
import { Damage } from '@bdeo-motor/smartphoto-entities';
import { DamageAction, SmartphotoService } from '../../../../services/smartphoto.service';

@Component({
  selector: 'app-smartphoto-damage-actions',
  templateUrl: './smartphoto-damage-actions.component.html',
  styleUrls: ['./smartphoto-damage-actions.component.scss']
})
export class SmartphotoDamageActionsComponent implements OnChanges {
  @Input({ required: true }) public damage?: Damage;

  protected readonly smartphotoService = inject(SmartphotoService);

  protected damageActions: DamageAction[] = [];

  public ngOnChanges(): void {
    if (!this.damage) {
      return;
    }

    this.damageActions = this.smartphotoService.getDamageActions(this.damage);
  }
}
